<template>
	<div
		class="relatedReading"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div v-if="data.content || data.data.length > 0">
			<div
				class="xgyd"
				:style="{
					backgroundImage: 'url(' + (data.backgroundImage == '' ? 'https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_1/xgyd_box.jpg' : data.backgroundImage) + ')',
					padding: data.contPadding,
				}"
			>
				<div class="yd_1" v-for="(item, index) in data.data" :key="index">
					<img :src="item.listImage" />
					<span @click="goToWx(item.WXHref)">{{ item.title }}</span>
				</div>
			</div>
		</div>

		<div v-else>
			<div class="xgyd">
				<div class="yd_1">
					<img src="https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_10/yd_1.png" />
					<span>1.男性不育，参鹿助你解“男”题</span>
				</div>
				<div class="yd_2">
					<img src="https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_10/yd_2.png" />
					<span>2.瘀血也会断了你的“香火”</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'relatedReading',
	props: ['data'],

	methods: {
		goToWx(href) {
			window.location.href = href;
		},
	},
};
</script>

<style lang="scss" scoped>
.xgyd {
	background-image: url('https://kchi.obs.cn-north-4.myhuaweicloud.com/jdzy/chinaMedVideo/listDetail_17/xgyd_box.jpg');
	background-repeat: no-repeat;
	background-size: 100% 100%;
	overflow: hidden;
	width: 100%;
	margin: 0 auto;
	padding: 90px 40px 40px;
	div {
		margin-top: 15px;
	}
	img {
		width: 50px;
		height: 50px;
		vertical-align: middle;
		margin-right: 20px;
	}
	span {
		color: #ffffff;
		font-size: 0.8125rem;
		text-decoration: underline;
		display: inline-block;
		width: 75%;
		vertical-align: middle;
		line-height: 25px;
	}
}
</style>